// Contains routes to all views
// Views related to home- and info pages are explicitly imported here
// Import views
import { createRouter, createWebHistory } from "vue-router";
import productsRoutes from "@/router/products/productsRoutes.js";
import { nextTick } from "@vue/runtime-core";

// Define routes and display names
const baseRoutes = [];

// Create router
const router = createRouter({
  // Enable history mode
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    // Scroll to top of page when navigating to new page
    document.getElementById("app").scrollIntoView();
    // Scroll to savedPosition when going back to a previously visited page
    nextTick(() => {
      if (savedPosition) {
        window.scrollTo({
          top: savedPosition.top,
          left: savedPosition.left,
          behavior: "smooth",
        });
      }
    });
  },
  // Use all routes
  routes: [...baseRoutes, ...productsRoutes],
});

export default router;
